/*
 localStorage/sessionStorage wrapper that uses in-memory object as fallback
 if the native version is unavailable or disabled

 Usage:
 var localStorage = require('./storage').local
 localStorage.setItem("key", "value")
*/
module.exports = {
  nativelySupported: isSupported('localStorage'),
  local: resolve('local'),
  session: resolve('session')
}

function resolve(storage) {
  storage = storage || 'local'
  var prop = storage + 'Storage'
  return isSupported(prop) ? window[prop] : generateFallbackStorage()
}

function generateFallbackStorage() {
  var store = {
    setItem: function(id, val) {
      return store[id] = String(val)
    },
    getItem: function(id) {
      return store.hasOwnProperty(id) ? String(store[id]) : null
    },
    removeItem: function(id) {
      return delete store[id]
    },
    clear: function() {
      for (var key in store) {
        if (store.hasOwnProperty(key) && typeof store[key] !== 'function') {
          delete store[key]
        }
      }
    }
  }
  return store
}

function isSupported(storage) {
  try {
    var x = '__storage_test__'
    window[storage].setItem(x, x)
    window[storage].removeItem(x)
    return true
  } catch (e) {
    return false
  }
}
